<template>
  <div class="organization-management">

    <div class="page-header">
      <div>
        <h2>Organization Management</h2>
      </div>
    </div>
    <section class="management-section">
      <div class="section-header">
        <div>
          <h3>Add New</h3>
          <p>Create a new organization member or patient.</p>
        </div>
      </div>
      <div class="management-grid">
        <div
          v-if="orgLevel === 'Main'"
          class="management-card"
          @click="openAction('organization')"
        >
          <div class="card-icon">+</div>
          <div class="card-content">
            <h4>Add Site</h4>
            <p>Create a new site or subsection.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('specialist')"
        >
          <div class="card-icon">+</div>
          <div class="card-content">
            <h4>Add Specialist</h4>
            <p>Create a new specialist for the organization.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('child')"
        >
          <div class="card-icon">+</div>
          <div class="card-content">
            <h4>Add Patient / Student</h4>
            <p>Create a new patient or student.</p>
          </div>
        </div>
      </div>
    </section>
    <h4>Linking and deleting coming soon!</h4>
    <!-- <section class="management-section">
      <div class="section-header">
        <div>
          <h3>Link Existing</h3>
          <p>Connect existing people and organizations.</p>
        </div>
      </div>
      <div class="management-grid">
        <div
          v-if="orgLevel === 'Main'"
          class="management-card"
          @click="openAction('linkOrganization')"
        >
          <div class="card-icon link-icon">↗</div>
          <div class="card-content">
            <h4>Link Organization</h4>
            <p>Connect an existing site to this organization.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('linkSpecialist')"
        >
          <div class="card-icon link-icon">↗</div>
          <div class="card-content">
            <h4>Link Specialist</h4>
            <p>Connect an existing specialist to this organization.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('linkChild')"
        >
          <div class="card-icon link-icon">↗</div>
          <div class="card-content">
            <h4>Link Patient / Student</h4>
            <p>Connect a patient or student to a specialist.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="management-section">
      <div class="section-header">
        <div>
          <h3>Delete</h3>
          <p>Delete existing patient/students and specialist.</p>
        </div>
      </div>
      <div class="management-grid">
        <div
          v-if="orgLevel === 'Main'"
          class="management-card"
          @click="openAction('deleteOrganization')"
        >
          <div class="card-icon link-icon">-</div>
          <div class="card-content">
            <h4>Delete Organization</h4>
            <p>Delete an existing site from this organization.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('deleteSpecialist')"
        >
          <div class="card-icon link-icon">-</div>
          <div class="card-content">
            <h4>Delete Specialist</h4>
            <p>Delete an existing specialist from this organization.</p>
          </div>
        </div>
        <div
          class="management-card"
          @click="openAction('deleteChild')"
        > 
          <div class="card-icon link-icon">-</div> 
          <div class="card-content">
            <h4>Delete Patient / Student</h4>
            <p>Delete a patient or student from a specialist.</p> 
          </div>
        </div>               
      </div>
    </section> -->

    <!-- ACTION MODAL -->
    <div v-if="selectedAction" class="modal-overlay" ref="actionModal">
        <div class="action-panel">

            <button
            class="close-button"
            @click="selectedAction = null"
            >
            ✕
            </button>

            <h3>{{ actionTitles[selectedAction] }}</h3>

            <!-- ==================== ADD ==================== -->

            <!-- ADD ORGANIZATION -->
            <div v-if="selectedAction === 'organization'">

            <div class="dynamic-grid">
                <div>
                <label>Site Name*</label>
                <input type="text" v-model="inputObjectData.org_name" :class="{ 'input-error': validationErrors.org_name }"/>
                </div>

                <div>
                <label>Job Title*</label>
                <input type="text" v-model="inputObjectData.jobTitle" :class="{ 'input-error': validationErrors.jobTitle }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Department*</label>
                <input type="text" v-model="inputObjectData.department" :class="{ 'input-error': validationErrors.department }"/>
                </div>

                <div>
                <label>Phone Number*</label>
                <input type="text" v-model="inputObjectData.phoneNumber" :class="{ 'input-error': validationErrors.phoneNumber}" />
                </div>
            </div>
            <div class="dynamic-grid">
                <div>
                <label>Category*</label>
                <select v-model="inputObjectData.category">
                    <option value="">Select</option>
                    <option>Medical</option>
                    <option>Education</option>
                </select>
                </div>
                <div>
                <label>Organization Type*</label>
                <select v-model="inputObjectData.organizationType">
                  <option value="">Select</option>
                  <option
                  v-for="option in organizationTypeOptions"
                  :key="option"
                  :value="option"
                  >
                  {{ option }}
                  </option>
                </select>
                </div>
            </div>
            <div class="dynamic-grid">
                <div>
                <label>Address 1*</label>
                <input type="text" v-model="inputObjectData.address1" :class="{ 'input-error': validationErrors.address1 }"/>
                </div>

                <div>
                <label>Address 2</label>
                <input type="text" v-model="inputObjectData.address2" />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>City*</label>
                <input type="text" v-model="inputObjectData.city" :class="{ 'input-error': validationErrors.city }"/>
                </div>

                <div>
                <label>State or Province*</label>
                <input type="text" v-model="inputObjectData.org_state" :class="{ 'input-error': validationErrors.org_state }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Country*</label>
                <input type="text" v-model="inputObjectData.country" :class="{ 'input-error': validationErrors.country }"/>
                </div>

                <div>
                <label>Zip or Postal Code*</label>
                <input type="text" v-model="inputObjectData.zipcode" :class="{ 'input-error': validationErrors.zipcode }"/>
                </div>
            </div>
            <div>
                <label>Email Address*</label>
                <input type="email" v-model="inputObjectData.email" :class="{ 'input-error': validationErrors.email }"/>
            </div>

            <div>
                <label>Password*</label>
                <input type="password" v-model="inputObjectData.password" :class="{ 'input-error': validationErrors.password }"/>
            </div>

            <div>
                <label>Confirm Password*</label>
                <input type="password" v-model="inputObjectData.confirmPassword" :class="{ 'input-error': validationErrors.confirmPassword }"/>
            </div>

            <div class="button-container">
                <button
                class="primary-button-sm-global"
                @click="submit('organization')"
                >
                Add Site
                </button>
            </div>

            </div>


            <!-- ADD SPECIALIST -->
            <div v-else-if="selectedAction === 'specialist'">

            <div class="dynamic-grid">
                <div>
                <label>First Name*</label>
                <input type="text" v-model="inputObjectData.firstName" :class="{ 'input-error': validationErrors.firstName }"/>
                </div>

                <div>
                <label>Middle Name</label>
                <input type="text" v-model="inputObjectData.middleName" />
                </div>
            </div>

            <div class="dynamic-grid">
              
                <div>
                <label>Last Name*</label>
                <input type="text" v-model="inputObjectData.lastName" :class="{ 'input-error': validationErrors.lastName }"/>
                </div>
                <div>
                <label>Pronouns*</label>
                <select v-model="inputObjectData.pronouns" :class="{ 'input-error': validationErrors.pronouns }">
                    <option value="">Select</option>
                    <option>He/Him</option>
                    <option>She/Her</option>
                    <option>They/Them</option>
                    <option>He/They</option>
                    <option>She/They</option>
                    <option>Other</option>
                    <option>Prefer Not to Say</option>
                </select>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Job Title*</label>
                <input type="text" v-model="inputObjectData.jobTitle" :class="{ 'input-error': validationErrors.jobTitle }"/>
                </div>

                <div>
                <label>Department*</label>
                <input type="text" v-model="inputObjectData.department" :class="{ 'input-error': validationErrors.department }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Type of Specialist</label>
                <select v-model="inputObjectData.specialistType">
                    <option value="">Not a Specialist</option>
                    <option value="Child Counselor">Child Counselor</option>
                    <option value="Language Therapist">Language Therapist</option>
                    <option value="Neuro-pediatrician">Neuro-pediatrician</option>
                    <option value="Occupational Therapist (OT)">
                    Occupational Therapist (OT)
                    </option>
                    <option value="Occupational Therapist Assistant (OTA)">
                    Occupational Therapist Assistant (OTA)
                    </option>
                    <option value="Physical Therapist/Kinesiologist">
                    Physical Therapist/Kinesiologist
                    </option>
                    <option value="Psychotherapist">Psychotherapist</option>
                    <option value="Psychologist">Psychologist</option>
                    <option value="Reading Specialist (RSP)">
                    Reading Specialist (RSP)
                    </option>
                    <option value="Social Worker">Social Worker</option>
                    <option value="Special Education Teacher">
                    Special Education Teacher
                    </option>
                    <option value="Speech & Language Pathologist (SLP)">
                    Speech & Language Pathologist (SLP)
                    </option>
                    <option value="Speech Therapist">Speech Therapist</option>
                </select>
                </div>

                <div>
                <label>Certification</label>
                <input
                    type="text"
                    v-model="inputObjectData.certification"
                />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Address 1*</label>
                <input type="text" v-model="inputObjectData.address1" :class="{ 'input-error': validationErrors.address1 }"/>
                </div>

                <div>
                <label>Address 2</label>
                <input type="text" v-model="inputObjectData.address2" />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>City*</label>
                <input type="text" v-model="inputObjectData.city" :class="{ 'input-error': validationErrors.city }"/>
                </div>

                <div>
                <label>State or Province*</label>
                <input type="text" v-model="inputObjectData.state" :class="{ 'input-error': validationErrors.state }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Country*</label>
                <input type="text" v-model="inputObjectData.country" :class="{ 'input-error': validationErrors.country }"/>
                </div>

                <div>
                <label>Zip or Postal Code*</label>
                <input type="text" v-model="inputObjectData.zipcode" :class="{ 'input-error': validationErrors.zipcode }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Phone Number*</label>
                <input type="text" v-model="inputObjectData.phoneNumber" :class="{ 'input-error': validationErrors.phoneNumber }"/>
                </div>

                <div>
                <label>Alternative Phone</label>
                <input
                    type="text"
                    v-model="inputObjectData.alternativePhone"
                />
                </div>
            </div>

            <div>
                <label>Email Address*</label>
                <input type="email" v-model="inputObjectData.email" :class="{ 'input-error': validationErrors.email }"/>
            </div>

            <div>
                <label>Password*</label>
                <input type="password" v-model="inputObjectData.password" :class="{ 'input-error': validationErrors.password }"/>
            </div>

            <div>
                <label>Confirm Password*</label>
                <input
                type="password"
                v-model="inputObjectData.confirmPassword"
                :class="{ 'input-error': validationErrors.confirmPassword }"/>
            </div>

            <div class="button-container">
                <button
                class="primary-button-sm-global"
                @click="submit('specialist')"
                >
                Add Specialist
                </button>
            </div>

            </div>


            <!-- ADD CHILD -->
            <div v-else-if="selectedAction === 'child'">

            <div class="dynamic-grid">
                <div>
                <label>First Name*</label>
                <input type="text" v-model="inputObjectData.firstName" :class="{ 'input-error': validationErrors.firstName }"/>
                </div>

                <div>
                <label>Middle Name</label>
                <input type="text" v-model="inputObjectData.middleName" />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Last Name*</label>
                <input type="text" v-model="inputObjectData.lastName" :class="{ 'input-error': validationErrors.lastName }"/>
                </div>
                <div>
                <label>Preffered Name</label>
                <input type="text" v-model="inputObjectData.prefferedName" />
                </div>
            </div>
            <div class="dynamic-grid">
              <div>
                <label>Pronouns*</label>
                <select v-model="inputObjectData.pronouns" :class="{ 'input-error': validationErrors.pronouns }">
                    <option value="">Select</option>
                    <option>He/Him</option>
                    <option>She/Her</option>
                    <option>They/Them</option>
                    <option>He/They</option>
                    <option>She/They</option>
                    <option>Other</option>
                    <option>Prefer Not to Say</option>
                </select>
                </div>
                <div>
                <label>Date of Birth*</label>
                <input type="date" v-model="inputObjectData.dateOfBirth" :class="{ 'input-error': validationErrors.dateOfBirth }"/>
                </div>
            </div>
            <div class="dynamic-grid">
                <div>
                <label>Race</label>
                <input type="text" v-model="inputObjectData.race"/>
                </div>
                <div>
                <label>Ethnicity</label>
                <input type="text" v-model="inputObjectData.ethnicity" />
                </div>
            </div>
            <div class="dynamic-grid">
                <div>
                <label>Grade</label>
                <input type="text" v-model="inputObjectData.grade" />
                </div>
                <div>
                <label>Native Language</label>
                <input type="text" v-model="inputObjectData.nativeLanguage" />
                </div>
            </div>
            <div class="dynamic-grid">
                <div>
                <label>Phone Number*</label>
                <input type="text" v-model="inputObjectData.phoneNumber" :class="{ 'input-error': validationErrors.phoneNumber }"/>
                </div>

                <div>
                <label>Email*</label>
                <input type="email" v-model="inputObjectData.email" :class="{ 'input-error': validationErrors.email }"/>
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Address 1*</label>
                <input type="text" v-model="inputObjectData.address1" :class="{ 'input-error': validationErrors.address1 }"/>
                </div>

                <div>
                <label>Address 2</label>
                <input type="text" v-model="inputObjectData.address2" />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>City*</label>
                <input type="text" v-model="inputObjectData.city" :class="{ 'input-error': validationErrors.city }"/>
                </div>

                <div>
                <label>State or Province*</label>
                <input type="text" v-model="inputObjectData.state" :class="{ 'input-error': validationErrors.state }" />
                </div>
            </div>

            <div class="dynamic-grid">
                <div>
                <label>Country*</label>
                <input type="text" v-model="inputObjectData.country" :class="{ 'input-error': validationErrors.country }"/>
                </div>

                <div>
                <label>Zip or Postal Code*</label>
                <input type="text" v-model="inputObjectData.zipcode" :class="{ 'input-error': validationErrors.zipcode }"/>
                </div>
            </div>

            <div class="button-container">
                <button
                class="primary-button-sm-global"
                @click="submit('child')"
                >
                Add Patient / Student
                </button>
            </div>

            </div>


            <!-- ==================== LINK ==================== -->

            <div v-else-if="selectedAction === 'linkOrganization'">

            <p>Select an existing organization to link.</p>
            <div class="search-bar">
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                  <circle cx="11" cy="11" r="6" stroke-width="2"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65" stroke-width="2"></line>
                </svg>
              </button>
              <input
                v-model="searchQuery"
                @input="fetchSearchFilter"
                placeholder="Search"
            />
            </div>
            <!-- YOUR LINK ORGANIZATION CODE GOES HERE -->
             <label>Existing sub-organizations</label>
              <select v-model="linkData.subOrgs">
                <!-- list of suborgs-->
              </select>
            <div class="button-container">
                <button class="primary-button-sm-global" @click="submit">
                Link Organization
                </button>
            </div>

            </div>


            <div v-else-if="selectedAction === 'linkSpecialist'">

              <p>Select an existing specialist to link.</p>
              <div class="search-bar">
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                  <circle cx="11" cy="11" r="6" stroke-width="2"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65" stroke-width="2"></line>
                </svg>
              </button>
              <input
                v-model="searchQuery"
                @input="fetchSearchFilter"
                placeholder="Search"
            />
            </div>
              <label>Your sub-organizations</label>
                <select v-model="linkData.subOrgs">
                  <!-- list of suborgs-->
                </select>
                <label>Existing specialists</label>
                <select v-model="linkData.specialists">
                  <!-- list of suborgs-->
                </select>
            <div class="button-container">
                <button class="primary-button-sm-global" @click="submit">
                Link Specialist
                </button>
            </div>

            </div>


            <div v-else-if="selectedAction === 'linkChild'">

            <p>Select an existing patient / student to link.</p>

              <div class="search-bar">
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                  <circle cx="11" cy="11" r="6" stroke-width="2"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65" stroke-width="2"></line>
                </svg>
              </button>
              <input
                v-model="searchQuery"
                @input="fetchSearchFilter"
                placeholder="Search"
            />
            </div>

              <label>Your sub-organizations</label>
                <select v-model="linkData.subOrgs">
                  <!-- list of suborgs-->
                </select>
                <label>{{selectedSuborganization}} specialists</label>
                <select v-model="linkData.specialists">
                  <!-- list of specialists-->
                </select>
                <label>Existing children</label>
                <select v-model="linkData.child">
                  <!-- list of suborgs-->
                </select>

            <div class="button-container">
                <button class="primary-button-sm-global" @click="submit">
                Link Patient / Student
                </button>
            </div>

            </div>


            <!-- ==================== DELETE ==================== -->

            <div v-else-if="selectedAction === 'deleteOrganization'">

            <p>
                Select an existing organization to delete.
            </p>

            <!-- YOUR DELETE ORGANIZATION CODE GOES HERE -->

            <div class="button-container">
                <button class="delete-button">
                Delete Organization
                </button>
            </div>

            </div>


            <div v-else-if="selectedAction === 'deleteSpecialist'">

            <p>
                Select an existing specialist to delete.
            </p>

            <!-- YOUR DELETE SPECIALIST CODE GOES HERE -->

            <div class="button-container">
                <button class="delete-button">
                Delete Specialist
                </button>
            </div>

            </div>


            <div v-else-if="selectedAction === 'deleteChild'">

            <p>
                Select an existing patient / student to delete.
            </p>

            <!-- YOUR DELETE CHILD CODE GOES HERE -->

            <div class="button-container">
                <button class="delete-button">
                Delete Patient / Student
                </button>
            </div>

            </div>

        </div>
        </div>
  </div>
</template>


<script>
import instance from "../axios.js";

export default {
  name: 'OrganizationManagement',

  data() {
    return {
        userID: null,
        mainorgID: null,
        orgLevel: null,
        selectedAction: null,

        validationErrors: {},

        actionTitles: {
        organization: 'Add Site',
        specialist: 'Add Specialist',
        child: 'Add Patient / Student',

        linkOrganization: 'Link Organization',
        linkSpecialist: 'Link Specialist',
        linkChild: 'Link Patient / Student',

        deleteOrganization: 'Delete Organization',
        deleteSpecialist: 'Delete Specialist',
        deleteChild: 'Delete Patient / Student'
        },

        inputObjectData: {
        firstName: '',
        middleName: '',
        lastName: '',
        org_name: '',
        prefferedName: '',
        pronouns: '',
        accessRole: 'App User',

        category: '',

        specialistType: '',
        certification: '',
        jobTitle: '',
        department: '',

        dateOfBirth: '',
        race:'',
        ethnicity: '',
        grade:'',
        nativeLanguage:'',

        address1: '',
        address2: '',
        city: '',
        org_state: '',
        state:'',
        country: '',
        zipcode: '',

        phoneNumber: '',
        alternativePhone: '',

        email: '',
        password: '',
        confirmPassword: ''
        },
        linkData: {
          subOrg: '',
          specialist: '',
          child: ''
        },
    };
  },
  watch: {
    selectedAction(newValue, oldValue) {
    console.log('3. selectedAction WATCHER:', {
      oldValue,
      newValue
    });

    this.$nextTick(() => {
      console.log('4. MODAL:', this.$refs.actionModal);

      console.log(
        '5. COMPONENT HTML:',
        this.$el.innerHTML.includes('modal-overlay')
      );
    });
  }
  },
  methods: {
    openAction(action) {
      this.selectedAction = action;
    },
    closeAction() {
      this.selectedAction = null;
    },
    togglePassword(number) {
        if (number == "1") {
          this.passwordShow1 = !this.passwordShow1;
        }

        if (number == "2") {
          this.passwordShow2 = !this.passwordShow2;
        }
      },
      validateEmail(email) {
        if (!email || email == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (email.match(/^\w+([.-]?\w+)_@\w+(_[_.-]?\w+)_(.\w{2,3})+$/)) {
          return {
            valid: false,
            error: "Please enter a valid email.",
          };
        }
        return { valid: true, error: null };
      },
      validatePassword(password) {
        if (!password || password.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (password.length < 8) {
          return {
            valid: false,
            error: "Password requires at least 8 characters",
          };
        }
        if (
          !/[~`!#$%@&*+=\-';,/{}|":<>]/g.test(password) ||
          !/\d/.test(password)
        ) {
          return {
            valid: false,
            error:
              "Password requires at least 1 number and 1 special character (e.g. '$', '%', '@').",
          };
        }
        return { valid: true, error: null };
      },
      validateConfirmPassword(confirmPassword, password) {
        if (!confirmPassword || confirmPassword.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (confirmPassword != password) {
          return {
            valid: false,
            error: "The passwords you entered did not match",
          };
        }

        return { valid: true, error: null };
      },
      validatePhoneNumber(phone) {
        if ((phone === null || phone.length === 0) && phone.length !== 10) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateAddForm() {
        const requiredFields = [];
        this.validationErrors = {};
      //   if (this.selectedAction === 'organization') {

      //   if (!this.inputObjectData.firstName) {
      //     this.validationErrors.firstName = true;
      //   }

      //   if (!this.inputObjectData.lastName) {
      //     this.validationErrors.lastName = true;
      //   }

      //   if (!this.inputObjectData.email) {
      //     this.validationErrors.email = true;
      //   }
      // }

      // return Object.keys(this.validationErrors).length === 0;

        if (this.selectedAction === 'organization') {
          requiredFields.push(
            'org_name',
            'jobTitle',
            'department',
            'phoneNumber',
            'category',
            'organizationType',
            'address1',
            'city',
            'stateOrProvince',
            'country',
            'zipCode',
            'email',
            'password',
            'confirmPassword'
          );
        }

        if (this.selectedAction === 'specialist') {
          requiredFields.push(
            'firstName',
            'lastName',
            'pronouns',
            'jobTitle',
            'department',
            'address1',
            'city',
            'stateOrProvince',
            'country',
            'zipCode',
            'phoneNumber',
            'email',
            'password',
            'confirmPassword'
          );
        }

        if (this.selectedAction === 'child') {
          requiredFields.push(
            'firstName',
            'lastName',
            'pronouns',
            'dateOfBirth'
          );
        }

        for (const field of requiredFields) {
          if (!this.inputObjectData[field]) {
            return false;
          }
        }

        return true;
      },
      async submit() {
        if (
          this.selectedAction === 'organization' ||
          this.selectedAction === 'specialist' ||
          this.selectedAction === 'child'
        ) {
          // if (!this.validateAddForm()) {
          //   alert('Please fill out all required fields.');
          //   return;
          // }
        }

        switch (this.selectedAction) {
          case 'organization':
            await this.addOrganization();
            break;

          case 'specialist':
            await this.addSpecialist();
            break;

          case 'child':
            await this.addChild();
            break;

          case 'linkOrganization':
            await this.linkOrganization();
            break;

          case 'linkSpecialist':
            await this.linkSpecialist();
            break;

          case 'linkChild':
            await this.linkChild();
            break;

          case 'deleteOrganization':
            await this.deleteOrganization();
            break;

          case 'deleteSpecialist':
            await this.deleteSpecialist();
            break;

          case 'deleteChild':
            await this.deleteChild();
            break;

          default:
            console.error('Unknown action:', this.selectedAction);
        }
      },
  async addOrganization() {
    try {
      const data = {
        pronouns: this.inputObjectData.pronouns,
        access_role: this.inputObjectData.accessRole,
        org_name: this.inputObjectData.org_name,
        category: this.inputObjectData.category,
        org_type: this.inputObjectData.organizationType,
        job_title: this.inputObjectData.jobTitle,
        department: this.inputObjectData.department,
        address_1: this.inputObjectData.address1,
        address_2: this.inputObjectData.address2,
        city: this.inputObjectData.city,
        state: this.inputObjectData.org_state,
        country: this.inputObjectData.country,
        zip_code: this.inputObjectData.zipcode,
        phone_number: this.inputObjectData.phoneNumber,
        email: this.inputObjectData.email,          
        password: this.inputObjectData.password,
        validationErrors: {}
      };

      console.log("ADD ORGANIZATION DATA:", data);
      console.log("EMAIL BEING SENT:", data.email);
      console.log("MAIN ORG ID:", this.mainorgID);
      const response = await instance.post(
        `/api/organization/create-sub-organization/${this.mainorgID}`,
        data
      );

      console.log("Organization created:", response.data);

      this.closeAction();

    } catch (error) {
      console.error("Error creating organization:", error);
    }
  },
  async addSpecialist() {
    try {
      const data = {
        first_name: this.inputObjectData.firstName,
        middle_name: this.inputObjectData.middleName,
        last_name: this.inputObjectData.lastName,
        pronouns: this.inputObjectData.pronouns,
        access_role: this.inputObjectData.accessRole,
        job_title: this.inputObjectData.jobTitle,
        department: this.inputObjectData.department,
        type_of_specialist: this.inputObjectData.specialistType,
        certification: this.inputObjectData.certification,
        address_1: this.inputObjectData.address1,
        address_2: this.inputObjectData.address2,
        city: this.inputObjectData.city,
        state: this.inputObjectData.stateOrProvince,
        country: this.inputObjectData.country,
        zip_code: this.inputObjectData.zipCode,
        phone_number: this.inputObjectData.phoneNumber,
        alternate_phone_number: this.inputObjectData.alternativePhone,
        email: this.inputObjectData.email,
        password: this.inputObjectData.password
      };

      const response = await instance.post(
        `/api/specialist/create-org-specialist/${this.mainorgID}`,
        data
      );

      console.log("Specialist created:", response.data);

      this.closeAction();

    } catch (error) {
      console.error("Error creating specialist:", error);
    }
  },
  async addChild() {
    try {
      const data = {
        first_name: this.inputObjectData.firstName,
        middle_name: this.inputObjectData.middleName,
        last_name: this.inputObjectData.lastName,
        pronouns: this.inputObjectData.pronouns,
        prefferedName: this.inputObjectData.prefferedName,
        date_of_birth: this.inputObjectData.dateOfBirth,
        race: this.inputObjectData.race,
        ethnicity: this.inputObjectData.ethnicity,
        grade: this.inputObjectData.grade,
        nativeLanguage: this.inputObjectData.nativeLanguage,
        phone_number: this.inputObjectData.phoneNumber,
        email: this.inputObjectData.email,
        address_1: this.inputObjectData.address1,
        address_2: this.inputObjectData.address2,
        city: this.inputObjectData.city,
        state: this.inputObjectData.stateOrProvince,
        country: this.inputObjectData.country,
        zip_code: this.inputObjectData.zipCode
      };

      const response = await instance.post(
        `/api/child/create-org-child`,
        data
      );

      console.log("Child created:", response.data);

      this.closeAction();

    } catch (error) {
      console.error("Error creating child:", error);
    }
  },
  async linkOrganization() {
      try {
        // Build your link data here

        // const response = await instance.post(
        //   "/api/organization/link",
        //   data
        // );

      } catch (error) {
        console.error("Error linking organization:", error);
      }
    },

    async linkSpecialist() {
      try {
        // Your linking logic

      } catch (error) {
        console.error("Error linking specialist:", error);
      }
    },

    async linkChild() {
      try {
        // Your linking logic

      } catch (error) {
        console.error("Error linking child:", error);
      }
    },
    async deleteOrganization() {
      try {
        const id = this.selectedOrganizationId;

        this.deleteWarning();
        await instance.delete(
          `/api/organization/${id}`
        );
        this.closeAction();

      } catch (error) {
        console.error("Error deleting organization:", error);
      }
    },
    async deleteSpecialist() {
      try {
        const id = this.selectedSpecialistId;

        this.deleteWarning();
        await instance.delete(
          `/api/specialist/${id}`
        );


        this.closeAction();

      } catch (error) {
        console.error("Error deleting specialist:", error);
      }
    },

    async deleteChild() {
      try {
        const id = this.selectedChildId;

        this.deleteWarning();
        await instance.delete(
          `/api/child/${id}`
        );

        this.closeAction();

      } catch (error) {
        console.error("Error deleting child:", error);
      }
    },
    async getOrgs(){
      try {
        const id = this.mainOrgID;

        await instance.get(`/api/organization-organization-junction/user/${id}/get-sub-orgs`)
      } catch (error){
        console.error("Error getting organization:", error);
      }
    },
    async getSpecialists(){
      try {
        const id = this.mainOrgID;

        await instance.get(`/api/organization-specialist-junction/user/${id}/get-specialists`)
      } catch (error){
        console.error("Error getting specialist:", error);
      }
    },
    async getChildren(){
      try {
        const id = this.mainOrgID;

        await instance.get(`/api/child-specialist-junction/user/${id}/get-children`)
      } catch (error){
        console.error("Error getting organization:", error);
      }
    },
    async deleteWarning(){
      try {
        //popup logic
      } catch (error){
        console.error("Error getting warning:", error);
      }
    },
    async getOrgLevel(){
        try {
        const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

        // get org_id from cookie
        const authResp = await fetch(`${baseUrl}/api/auth/get-access-cookie-data`, {
          credentials: "include",
        });
        if (!authResp.ok) throw new Error("Failed to fetch auth cookie data");
        const authData = await authResp.json();
        const ID = authData.id;

        const response = await fetch(
          `${baseUrl}/api/organization/user/${ID}`
        );

        const data = await response.json();

        this.mainorgID = data.org_id;
        this.orgLevel = data.org_level;

      }catch (err) {
        console.error("Error fetching students:", err);
      }
    },
  },
  mounted() {
    this.getOrgLevel();
  },
  computed: {
    organizationTypeOptions() {
      switch (this.inputObjectData.category) {
      case 'Medical':
      return [
      'Clinic',
      'Medical Office',
      'Hospital',
      'Mental Health Center',
      'Rehabilitation Center',
      'Telehealth'
      ];
      case 'Education':
      return [
      'Elementary',
      'Middle',
      'High',
      'Private',
      'Charter',
      'Magnet',
      'Virtual',
      'Special Education',
      'Religious',
      'Specialized (STEM, Art, etc.)'
      ];
      default:
      return [];
      }
    }
  }
};
</script>


<style scoped>

.organization-management {
  padding: 40px 60px;
  color: black;
  font-size: 16px;
  max-width: 1100px;
  margin: 0 auto;
}
.page-header {
  margin-top: 50px;
  margin-bottom: 15px;
}

.page-header h2 {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
}

.page-header p {
  margin-top: 8px;
  color: #667085;
  font-size: 14px;
}
.management-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}

.section-header {
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
}

.section-header p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
}
.management-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.management-card {
  display: flex;
  align-items: center;

  padding: 18px;

  border: 1px solid #e4e4e4;
  border-radius: 12px;

  cursor: pointer;

  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s ease;
}

.management-card:hover {
  transform: translateY(-2px);
  border-color: #d89c29;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.card-icon {
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: #fff5e3;
  color: #9d5f0e;

  font-size: 25px;
  font-weight: 400;

  margin-right: 15px;
}

.link-icon {
  font-size: 20px;
}
.card-content {
  flex: 1;
}

.card-content h4 {
  margin: 0;

  font-size: 15px;
  font-weight: 600;
}

.card-content p {
  margin: 5px 0 0;

  font-size: 12px;
  color: #667085;
}
.arrow {
  color: #98a2b3;
  font-size: 20px;
}
.modal-overlay {

  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.35);

  display:flex;
  justify-content:center;
  align-items:center;

  z-index:1000;

}
.action-panel {
  position: relative;
  width:600px;
  max-height:80vh;
  overflow-y: auto;
  background:white;

  border-radius:16px;

  display:flex;
  flex-direction:column;
  padding:28px;

  box-shadow:
    0 20px 50px rgba(0,0,0,0.25);

  animation: pop .2s ease;
}

.action-panel h3 {
  margin-top: 0;
}
.action-panel input,
.action-panel select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  outline: none;
}
.close-button {
  position: absolute;

  top: 15px;
  right: 15px;

  border: none;
  background: none;

  font-size: 18px;
  cursor: pointer;
}

@media (max-width: 750px) {

  .organization-management {
    padding: 25px;
  }

  .management-grid {
    grid-template-columns: 1fr;
  }

}
/* section {
    display: flex;
    flex-direction: column;
    align-items: center;
  } */

  input {
    width: 100%;
  }

  .card-band-styling {
    max-width: 800px;
    width: 75%;
  }

  .warning-alert {
    background-color: #ED7878;
    border-radius: 5px;
    margin: 5px 0;
  }

  h2 {
    text-align: center;
  }

  select {
    width: 100%;
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .dynamic-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    column-gap: 3rem;
  }
  .dynamic-grid p{
    font-size: 10px;
  }
  .input-error {
  border: 1px solid #dc3545 !important;
}

</style>